<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<img src="../../assets/img_h5/services/banner_1.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="msg_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="400"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">Edit Email</div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div v-if="isOne" class="title">Enter your new email address</div>
					<div v-if="!isOne" class="title">Verify email address</div>
					<div v-if="!isOne" class="text">
						To verify your email, we've sent a One Time Password (OTP) to <span class="email">{{ ruleForm.email }}</span>. <span class="btn" @click="isOne = true;">Change email</span>
					</div>
					<el-form :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm" label-width="100px" class="demo-ruleForm" @submit.native.prevent>
						<el-form-item v-if="isOne" label="Email" prop="email">
							<el-input v-model="ruleForm.email" placeholder="Enter" @keyup.enter.native="saveEdit('ruleForm')"></el-input>
						</el-form-item>
						<el-form-item v-if="!isOne" label="Enter OTP" prop="OTP">
							<el-input v-model="ruleForm.OTP" placeholder="Enter" @keyup.enter.native="saveEdit('ruleForm')"></el-input>
						</el-form-item>
					</el-form>
					<div class="btn_box">
						<van-button color="#E37542" block class="btn_el" @click="saveEdit('ruleForm')">
							{{ isOne ? 'Verify' : 'Edit' }}
						</van-button>
					</div>
					<div v-if="!isOne" class="btn_tips" @click="resend">Resend OTP</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import contact from '@/component/h5/contact.vue'  //联系我们组件
import { UPURL } from '@/util/util.js';
import { sendEmailCode, editEmail } from '@/api/public.js';
import md5 from 'js-md5';
import moment from 'moment';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			isOne: true,
			ruleForm: {
				email: '',
				OTP: ''
			},
			rules: {
				email: [
					{ required: true, message: 'Please enter your email address', trigger: 'blur' }
				],
				OTP: [
					{ required: true, message: 'Please enter OTP', trigger: 'blur' }
				]
			}
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	methods: {
		//重发
		resend() {
			let that = this;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			//获取验证码
			sendCode({
				email: that.ruleForm.email,
				sign: md5(that.ruleForm.email + 'jtests')
			}).then(res => {
				that.$toast.clear();
				if(res.dycode) {
					that.$dialog.alert({
						title: 'Tips',
						message: 'You have unsubscribed from our mailing system and will no longer receive updates, offers, or important communications from us. If this was unintentional, please contact us or re-subscribe to stay connected.<br /><a href="https://www.mysubmail.com/subscribe/qLXii" style="color: #006BB3;text-decoration:underline;" target="_blank">Click to subscribe again</a>',
						confirmButtonText: 'Close',
						// confirmButtonColor: '#006BB3'
					}).then(() => {});
				}else {
					that.isOne = false;
					that.$toast('Verification code sent successfully');
				}
			});
		},
		//点击确定
		saveEdit(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					if(!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(that.ruleForm.email)) {
						that.$toast('Email must be formatted correctly.');
						return false;
					}
					that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
					if(that.isOne) {
						//获取验证码
						sendEmailCode({
							email: that.ruleForm.email,
							sign: md5(that.ruleForm.email + 'jtests')
						}).then(res => {
							that.$toast.clear();
							if(res.dycode) {
								that.$dialog.alert({
									title: 'Tips',
									message: 'You have unsubscribed from our mailing system and will no longer receive updates, offers, or important communications from us. If this was unintentional, please contact us or re-subscribe to stay connected.<br /><a href="https://www.mysubmail.com/subscribe/qLXii" style="color: #006BB3;text-decoration:underline;" target="_blank">Click to subscribe again</a>',
									confirmButtonText: 'Close',
									// confirmButtonColor: '#006BB3'
								}).then(() => {});
							}else {
								that.isOne = false;
								that.$toast('Verification code sent successfully');
							}
						});
					}else {
						//修改邮箱
						editEmail({
							email: that.ruleForm.email,
							code: that.ruleForm.OTP
						}).then(res => {
							that.$toast.clear();
							localStorage.setItem('email', that.ruleForm.email);
							if(res.data.first_name) {
								localStorage.setItem('firstName', res.data.first_name);
							}
							that.$toast('Email modification successful');
							setTimeout(() => {
								that.$router.push({ path: '/information' });
							}, 500);
						});
					}
				}
			})
		},
		goConditions() {
			this.$router.push('/terms-and-conditions');
		},
		goPrivacy() {
			this.$router.push('/privacy-policy');
		},
		goHome() {
			this.$router.push('/');
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #000000;
	font-size: 14px;
	//块1
	.block_1{
		padding: 50px 20px;
		.block_1_main{
			width: 100%;
			margin: 0 auto;
			.demo-ruleForm{
				padding-top: 10px;
			}
			.tips{
				padding-top: 50px;
				font-size: 16px;
				span{
					color: #0096E3;
					font-size: 16px;
					text-decoration: underline;
					cursor: pointer;
					user-select: none;
				}
			}
			.btn_tips{
				padding-top: 12px;
				text-align: center;
				font-size: 16px;
				color: #006BB3;
				cursor: pointer;
				user-select: none;
			}
			.btn_box{
				margin-top: 30px;
				.btn_el{
					height: 50px;
					padding: 4px 0 1px 0;
					font-size: 20px;
					border-radius: 6px;
				}
			}
			.text{
				font-size: 16px;
				.btn{
					color: #0096E3;
					font-size: 16px;
					cursor: pointer;
					user-select: none;
				}
				.email{
					color: #808080;
					font-size: 16px;
				}
			}
			.title{
				font-size: 30px;
				color: #006BB3;
				font-weight: bold;
			}
		}
	}
	//banner
	.banner_box{
		position: relative;
		.msg_box{
			width: 100%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			padding: 0 20px;
			text-align: center;
			.txt{
				font-size: 18px;
				color: #ffffff;
			}
			.tit{
				font-size: 36px;
				color: #ffffff;
			}
		}
		img{
			width: 100%;
		}
	}
}
</style>
<style scoped>
>>> .el-form--label-top .el-form-item__label{
	padding-bottom: 0;
	color: #006BB3;
	font-size: 16px;
}
>>> .el-input__inner{
	height: 56px;
	font-size: 18px;
	border: 1px solid #808080;
}
</style>